export const demoDmfData = [
  {
    imageId: '65e7f1b3de780ec6110720a8',
    teeth: [],
  },
  {
    imageId: '65e7f1b40ab31a7cd26e4bb9',
    teeth: [],
  },
  {
    imageId: '65e7f1b4fea6f0c9e77879a7',
    teeth: [],
  },
  {
    imageId: '65e7f1b4a7b3b5f6dbaef7d2',
    teeth: [],
  },
  {
    imageId: '65e7f1b4126aaed8772dcc8b',
    teeth: [],
  },
  {
    imageId: '65e7f1b454354d681d729449',
    teeth: [
      { toothId: '14', dmf: 0.13, decayOnCrown: 1 },
      { toothId: '15', dmf: 0.17, decayOnCrown: 1 },
    ],
  },
  {
    imageId: '65e7f1b4df167d25ae2fdf6d',
    teeth: [
      { toothId: '14', dmf: 0.13, decayOnCrown: 1 },
      { toothId: '15', dmf: 0.17, decayOnCrown: 1 },
    ],
  },
  {
    imageId: '65e7f1b464f388fe442d71f0',
    teeth: [
      { toothId: '31', dmf: 0.22, decayOnCrown: 1 },
      { toothId: '32', dmf: 0.43, decayOnCrown: 3 },
    ],
  },
  {
    imageId: '65e7f1b4e41a6041da2baeaf',
    teeth: [
      { toothId: '31', dmf: 0.22, decayOnCrown: 1 },
      { toothId: '32', dmf: 0.43, decayOnCrown: 3 },
    ],
  },
  {
    imageId: '65e7f1b4875af15727dce93d',
    teeth: [
      { toothId: '14', dmf: 0.13, decayOnCrown: 1 },
      { toothId: '18', dmf: 0.49, decayOnCrown: 3 },
      { toothId: '19', dmf: 0.03, decayOnCrown: 1 },
      { toothId: '20', dmf: 0.03, decayOnCrown: 1 },
    ],
  },
  {
    imageId: '65e7f1b4f04651f0463b9334',
    teeth: [
      { toothId: '14', dmf: 0.13, decayOnCrown: 1 },
      { toothId: '15', dmf: 0.17, decayOnCrown: 1 },
      { toothId: '18', dmf: 0.49, decayOnCrown: 3 },
      { toothId: '19', dmf: 0.03, decayOnCrown: 1 },
      { toothId: '20', dmf: 0.03, decayOnCrown: 1 },
    ],
  },
  {
    imageId: '65e7f1b535fea1d4df7b6fe6',
    teeth: [{ toothId: '31', dmf: 0.22, decayOnCrown: 1 }],
  },
  {
    imageId: '65e7f1b47318e1c9d9a3b6dc',
    teeth: [{ toothId: '31', dmf: 0.22, decayOnCrown: 1 }],
  },
  {
    imageId: '65e7f1b5475cec1f655141f5',
    teeth: [],
  },
  {
    imageId: '65e7f1b449848a329a0c2550',
    teeth: [],
  },
  {
    imageId: '65e7f1b4ec50863726c204e5',
    teeth: [],
  },
  {
    imageId: '65e7f1b435a2a5ace608759e',
    teeth: [{ toothId: '18', dmf: 0.49, decayOnCrown: 3 }],
  },
  {
    imageId: '65e7f1b412807d8b7a4bdb9a',
    teeth: [{ toothId: '18', dmf: 0.49, decayOnCrown: 3 }],
  },
];

export type TDemoSegmentations = {
  imageId: string;
  teeth?: Array<{
    toothId: string;
    dmf?: number;
    decayOnCrown?: number;
    caries?: any[];
    isPartial?: boolean;
  }>;
};
